import { Map } from "immutable";

import actionTypes from "../../../action-types";
import Location from "../../../models/state/locations/location/Location";
import { Locations } from "../../../models/state/locations/Locations";

export default function locationsReducer(
  locations: Locations = Map<string, Location>(),
  action: Record<string, any>
) {
  switch (action.type) {
    case actionTypes.ADD_LOCATIONS:
      const data = action.payload.locations;
      return data.reduce(
        (init: any, location: any) =>
          init.set(location.id, new Location(location)),
        locations
      );

    default:
      return locations;
  }
}
